import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["productLine", "navItem", "screen"];
import PartnerProgramBanner from 'pricing-pages-ui/components/banners/PartnerProgramBanner';
import PromotionBannerContainer from 'pricing-pages-ui/components/banners/PromotionBannerContainer';
import EnvironmentWrapper from 'pricing-pages-ui/components/common/env/EnvironmentWrapper';
import styled from 'styled-components';
import FintechFireAlarmBanner from '../common/FintechFireAlarmBanner';
import ActiveQuoteBanner from './ActiveQuoteBanner';
import BannerHierarchySection from './BannerHierarchySection';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PromotionGrid = styled.div.withConfig({
  displayName: "BannerSection__PromotionGrid",
  componentId: "sc-1huz8dv-0"
})(["display:grid;grid-auto-rows:auto;grid-row-gap:16px;width:100%;&:not(:empty){margin-bottom:16px;}"]);
const BannerSection = _ref => {
  let {
      productLine = ProductLines.MARKETING,
      navItem,
      screen
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(PromotionGrid, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(FintechFireAlarmBanner, {}), /*#__PURE__*/_jsx(PromotionBannerContainer, {
      productLine: productLine
    }), /*#__PURE__*/_jsx(EnvironmentWrapper, {
      authedNode: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BannerHierarchySection, {
          productLine: productLine,
          navItem: navItem
        }), /*#__PURE__*/_jsx(PartnerProgramBanner, {}), /*#__PURE__*/_jsx(ActiveQuoteBanner, {
          productLine: productLine,
          screen: screen
        })]
      }),
      publicNode: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(BannerHierarchySection, {
          productLine: productLine,
          navItem: navItem
        })
      })
    })]
  }));
};
export default BannerSection;